import React from 'react';
import { spinner_linear } from '../../../assets/images';

const Spinner = ({ classes = '' }) => {
  return <img src={spinner_linear} alt='' className={`inline animate-spin ${classes}`} />;
};

export default Spinner;
